import React from 'react';
import Image from 'next/image';
import { useDispatch } from 'react-redux';

import { closeModal, openModal } from 'features/utilsSlice';
import TransitionDialog from 'components/TransitionDialog';
import BottomButtons from 'components/BottomButtons';
import useModalOpen from 'hooks/useModalOpen';
import styles from 'styles/components/milestones/UploadViewsDialog.module.scss';
import ExternalLink from 'components/ExternalLink';

const UploadViewsDialog = ({ handleAttachViews, milestone }) => {
  const open = useModalOpen('Upload Views');
  const dispatch = useDispatch();
  const deliveryScreenshot = milestone.delivery_screenshot.url;

  const handleClose = () => dispatch(closeModal('Upload Views'));

  const handleClick = () => {
    handleAttachViews();
    dispatch(openModal({ name: 'Views' }));
  };

  return (
    <TransitionDialog open={open} handleClose={handleClose} noCloseIcon>
      <div className={styles.viewsContainer}>
        <div className={styles.imageContainer}>
          <Image layout="fill" src={deliveryScreenshot} alt="Delivery Screenshot" unoptimized />
        </div>

        <div className={styles.content}>
          <h1>Nice!</h1>

          <h3>Now upload a screenshot containing proof of audience views</h3>

          <p>
            This needs to clearly show to your client that you have delivered at least the minimum
            number of views that you had guaranteed. If it does not exceed this amount, your client
            has the right to demand that you extend your deliverable time until fulfilled.
          </p>

          <h4>
            <ExternalLink
              mobileUrl="https://gigsocial.crisp.help/en-us/article/completing-a-gig-vdn6lk/?bust=1708557020756"
              desktopUrl="https://gigsocial.crisp.help/en-us/article/completing-a-gig-vdn6lk/?bust=1708557020756"
              target="_blank"
              rel="noopener noreferrer"
              page="Completing a Gig"
              preview="url"
            >
              How do I find this information?
            </ExternalLink>
          </h4>
        </div>

        <BottomButtons
          text="Go Back"
          textContained="Upload Views"
          handleClose={handleClose}
          handleClick={handleClick}
          fixed
        />
      </div>
    </TransitionDialog>
  );
};

export default UploadViewsDialog;
